import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import { toBlob, toPng } from "html-to-image";
import { useRef, useState } from "react";
import { CircularProgress } from "@nextui-org/react";
import { useGlobalData } from "@/contexts/GlobalData";
import { useNotify } from "@/contexts/NotifyProvider";
interface SharePropsType extends GeneralPropsType {
  elementId: string;
  backgroundColor?: string;
  skipFonts?: boolean;
  backupMessage?: string;
  shareTitle?: string;
  message?: string;
}
function Share({
  children,
  className,
  elementId,
  backgroundColor,
  skipFonts = true,
  message,
  backupMessage,
  shareTitle = "Shared Image"
}: SharePropsType) {
  const {
    translate,
    runEffectNavigation
  } = useGlobalData();
  const [isRepairing, setIsRepairing] = useState(false);
  const noti = useNotify();
  function blobToBase64(blob: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve((reader.result as any).split(",")[1]); // Lấy phần Base64 (cắt bỏ phần `data:image/png;base64,`)
      };
      reader.onerror = error => {
        reject(error); // Nếu có lỗi xảy ra
      };
      reader.readAsDataURL(blob); // Đọc blob như một URL Data (Base64)
    });
  }
  const handleShareImage = async () => {
    const el = document.getElementById(elementId);
    if (el) {
      try {
        // Check if the Web Share API is available
        if (!navigator.share) {
          // noti?.error(translate("Sharing is not supported on your device or browser"));
          throw new Error("Sharing is not supported on your device or browser");
        }
        setIsRepairing(true);
        console.log("start");
        const blob = await toBlob(el, {
          quality: 1,
          cacheBust: true,
          skipFonts: skipFonts,
          backgroundColor
        });
        if (!blob) return;

        // blobToBase64(blob)
        //     .then((base64) => {
        //         console.log("Base64:", base64);
        //     })
        //     .catch((error) => {
        //         console.error("Error:", error);
        //     });
        const file = new File([blob], "shared-image.png", {
          type: "image/png"
        });
        try {
          console.log("share", file);
          const res = await navigator.share({
            title: shareTitle,
            text: message,
            files: [file]
          });
          console.log("🚀 ~ handleShareImage ~ res:", res);
          setIsRepairing(false);
          runEffectNavigation("success");
        } catch (error) {
          return;
        }
      } catch (error) {
        setIsRepairing(false);
        console.error("Error capturing image:", error);
        noti?.error(translate("Sharing is not supported on your device or browser"));
        runEffectNavigation("error");
        return;
      }
    }
  };
  return <div onClick={handleShareImage} className={clsx("relative", styles.container, className)} data-sentry-component="Share" data-sentry-source-file="index.tsx">
            {children}
            {isRepairing && <div className="px-2 py-1 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 min-h-full !min-w-full  bg-black rounded-2xl flex items-center gap-1 justify-center text-[0.8em] text-secondary">
                    <CircularProgress strokeWidth={3} color="secondary" classNames={{
        svg: "!size-4"
      }} />
                    {translate("preparing image")}
                </div>}
        </div>;
}
export default Share;